<template>
	<nav aria-label="Page Navigation" class="text-center">
		<ul class="pagination">
			<li v-for="(link, linkIdx) in links"
				:class="{
					'active' : link.active,
					'disabled': link.url == null
				}"
			>
				<a href="#" :aria-label="link.label" @click="$emit('page-nav', linkIdx)">
					<span aria-hidden="true" v-html="link.label">
					</span>
				</a>
			</li>
		</ul>
	</nav>
</template>
<script>
export default {
	props: {
		links: {
			type: Array,
			required: true
		},
	},
}
</script>